const navLinkStyledConfirmTenant = {
  text: 'Go back to home page to enter'
};

export default navLinkStyledConfirmTenant;
